import { useState, type FormEvent } from 'react';
import { useMutation } from '@tanstack/react-query';

import { api, ApiError } from '../api/client';
import { useAuth } from '../lib/auth';

export function Login() {
  const { refresh } = useAuth();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [identifier, setIdentifier] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const mutation = useMutation({
    mutationFn: async () => {
      if (mode === 'register') {
        await api.register({ username, email, password });
      }
      await api.login({
        identifier: mode === 'register' ? username : identifier,
        password,
      });
    },
    onSuccess: refresh,
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    mutation.mutate();
  };

  const error =
    mutation.error instanceof ApiError ? mutation.error.message : mutation.error ? 'Something went wrong' : null;

  return (
    <div className="center">
      <form className="card auth-card" onSubmit={onSubmit}>
        <h1 className="brand">newsfeed</h1>
        <p className="muted">Your feed. Your weights. Your rules.</p>

        {mode === 'register' && (
          <>
            <label>
              Username
              <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
            </label>
            <label>
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </label>
          </>
        )}

        {mode === 'login' && (
          <label>
            Username or email
            <input value={identifier} onChange={(e) => setIdentifier(e.target.value)} autoComplete="username" required />
          </label>
        )}

        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
            required
          />
        </label>

        {error && <p className="error">{error}</p>}

        <button type="submit" className="primary" disabled={mutation.isPending}>
          {mutation.isPending ? '…' : mode === 'register' ? 'Create account' : 'Log in'}
        </button>

        <button
          type="button"
          className="link"
          onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
        >
          {mode === 'login' ? 'Need an account? Register' : 'Have an account? Log in'}
        </button>
      </form>
    </div>
  );
}
